import { useState } from 'react';
import { ChannelIcon } from '@weareopenr/component-library';

interface IChannelLogo {
  src: string | undefined;
  alt: string;
  className?: string;
}

const ChannelLogo = ({ src, alt, className }: IChannelLogo) => {
  const [hasError, setHasError] = useState(false);

  if (!src || hasError) {
    return <ChannelIcon size="large" />;
  }

  return <img className={className} src={src} alt={alt} onError={() => setHasError(true)} />;
};

export default ChannelLogo;
